import { render, staticRenderFns } from "./Repasses.vue?vue&type=template&id=c2c91e96&lang=pug"
import script from "./Repasses.vue?vue&type=script&lang=js"
export * from "./Repasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports